var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:("chart" + _vm.id),staticStyle:{"width":"100%"},attrs:{"id":("chart" + _vm.id)}})}
var staticRenderFns = []

export { render, staticRenderFns }